<input class="search-bar"
       type="text"
       placeholder="Suchen..."
       (keyup)="onInputChange($event)">
